module.exports = __webpack_public_path__ + "static/media/Building A-1-Meter_MDB-B_Area.e2960a03.jpg";